
import React from 'react';
import { Paper, Typography, Grid, Box, Chip } from '@mui/material';
import CustomButton from '../../../core/components/ui/CustomButton';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from 'react-router-dom';

const DetailItem = ({ label, value }) => (
  <Box mb={2}>
    <Typography variant="subtitle2" color="gray">
      {label}
    </Typography>
    <Typography variant="body1">{value ?? '—'}</Typography>
  </Box>
);

const formatDate = (dateString) => {
  const options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
  return new Date(dateString).toLocaleString(undefined, options);
};

export default function ViewDeviceComponent ({data, setViewDeviceDetails}) {

    const navigate = useNavigate();

    const handleBack = () => {
       setViewDeviceDetails(false)
    }

    const DeviceStatusStyles = {
      Active: { backgroundColor: "#e8f5e9", color: "#4caf50" },
      Deactivated: { backgroundColor: "#F3F4F6", color: "#6B7280" },
      Pending: { backgroundColor: "#FEF9C3", color: "#854D0E" },
    };

    console.log('data', data)

    return(
        <Box>
            <CustomButton
                variant="text" 
                startIcon={<ArrowBackIcon fontSize="small" />}
                label="Back to Device list"
                customStyles={{fontSize: 14, mt: 1, mb: 2, ml: "-20px"}}
                onClick={handleBack}
            />
            <Paper sx={{ p: 4, color: 'white', borderRadius: 2 }}>
                {/* <Typography variant="h5" gutterBottom>
                    Device Detail
                </Typography> */}
                <Grid container spacing={2}>
                    <Grid item size={{xs: 6}}>
                    <DetailItem label="Device ID" value={data?.device_id} />
                    <DetailItem label="Manufacturer" value={data?.manufacturer} />
                    <DetailItem label="Model" value={data?.model} />
                    <DetailItem label="OS Version" value={data?.os_version}/>
                    </Grid>
                    <Grid item size={{xs: 6}}>
                    <DetailItem label="Entry Type" value={data?.entry_type} />
                    <DetailItem label="Status" value={
                        <Chip
                            label={data?.status}
                            style={DeviceStatusStyles[data?.status] || {}}
                            size="small"
                        />} />
                    <DetailItem label="Created Time"  value={formatDate(data?.created_time)}/>
                    <DetailItem label="Updated Time"  value={formatDate(data?.updated_time)} />
                    </Grid>
                </Grid>
            </Paper>
            
        </Box>
    )
}